












import { defineClassComponent } from '@/hooks'
import { onMounted, onUpdated, ref } from '@vue/composition-api'

export default defineClassComponent<{
  noSafeArea?: boolean
}>(
  {
    inheritAttrs: false,
    props: ['noSafeArea'],
  },
  ({ ctx }) =>
    class {
      constructor() {
        onMounted(this.updateBarHeight)
        onUpdated(this.updateBarHeight)
      }

      barHeight = ref(0)

      updateBarHeight = () => {
        setTimeout(() => {
          this.barHeight.value =
            (ctx.$el as HTMLDivElement)?.firstElementChild?.clientHeight || 0
        }, 60)
      }
    },
)
